module.exports = __webpack_public_path__ + "static/dragonborn-flame-tongue-AYAGWW-ee7b70cf82a5be13177798636faa7b6a.png";